import { EventBus } from '@/event-bus';
import Vue from 'vue';

export default Vue.extend({
  methods: {
    closeFullscreenWrapper(goToRoute = false): void {
      EventBus.$emit('closeFullscreenWrapper', goToRoute);
    },
  },
});
